const usernameRegexWhitespaces = new RegExp(/\S/)
const errorMessageWhitespaces = 'Must contains characters.'

export const usernameChecker = {
  checkWhitespaces: usernameRegexWhitespaces,
  errorWhitespaces: errorMessageWhitespaces,
}
